import { RotateCw } from 'lucide-react';
import { Button, EmptyState } from '@platform/design-system';
import { useTranslation } from '@platform/i18n';

export const LoadFailed = ({
  description,
  onRetry,
}: {
  description?: string | undefined;
  onRetry: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <EmptyState
      title={t('catalog.loadFailed')}
      description={description}
      action={
        <Button icon={<RotateCw size={20} aria-hidden="true" />} variant="outline" onClick={onRetry}>
          {t('common.retry')}
        </Button>
      }
    />
  );
};
